import styled from "styled-components";
import { theme } from "../../themes/default";
import { respondTo } from "../../utils/breakpoints";
import { SubHeader } from "../../components/typography";
import { FlexBox } from "../../components/global/flexbox";
import { Flex } from "../news/styled.components";
import Slider from "react-slick";

export const MainHeader = styled.h1`
  color: white;
  text-align: center;
  font-size: 24px;
  line-height: 120%;
  margin-top: 0px;
  ${respondTo.m`
    font-size: 48px;
  `}
`;

export const MainImg = styled.img`
  width: 350px !important;
  height: auto;
`

export const MpkStyledLink = styled.a`
  color: ${(props) => props.theme.colors.uiWhite};
  text-decoration: none;
  cursor: pointer;
  &:hover {
    color: ${(props) => props.theme.colors.uiBlue};
  }
`;

export const MpkSlider = styled(Slider)`
  z-index: 2;  
  > * .slick-track, .slick-list, .slick-slider {
    max-height: 500px;
  }
  #mpk-page > div > section:nth-child(6) > div > div > div > div > div.slick-slide.slick-active.slick-current > div {
  }
`
export const SliderImgWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const SliderItemImage = styled.img`
  width: 100%;
  height: auto;
`


export const SponsorImage = styled.img`
  width: 100%;
  margin: 10px;
  ${respondTo.m`
    max-width: 21%;
  min-width: 200px;
  margin: 0 20px;
  height: auto;
  `}
  &.full {
    width: 850px;
    max-width: 100%;
  }
`
export const AgendaNav = styled.div`
  font-size: 24px;
  padding: 12px;
  text-align: center;
`

export const ImageGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
`

export const MPKSubHeader = styled(SubHeader)`
  color: ${(props) => props.theme.colors.uiDarkBlue};
  text-align: center;
  margin: 24px 0;
  &.inverted {
  color: ${(props) => props.theme.colors.uiWhite};
  }
`

export const AgendaTitleWrapper = styled(Flex)`
  margin-bottom: 24px;
  flex-direction: row;
  justify-content: flex-start;
  gap: 12px;
  border-bottom: 1px solid lightgrey;
  ${respondTo.m`
    flex-direction: row;
  `}
`
export const ContentWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items:center !important;
  height: 100%;
  ${respondTo.m`
    align-items: flex-start !important;
    flex-direction: column;
  `}
  &.center {
    justify-content: center !important;
  }
`

export const MpkInverviewFlex = styled(Flex)`
  padding-bottom: 64px !important;
`;

export const MPKFundingInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const AgendaSubHeader = styled(SubHeader)`
  cursor: pointer;
  text-align: center;
  padding: 12px 36px;
  border-radius: 12px 12px 0 0;
  border: 2px solid;
  border-bottom: 0px;
  border-color: ${(props) => props.theme.colors.uiDarkBlue};
  color: ${(props) => props.theme.colors.uiDarkBlue};
  &:hover {
    color: ${(props) => props.theme.colors.uiDarkBlue};
  }
  &.active {
    color: white;
    background-color: ${(props) => props.theme.colors.uiDarkBlue};
  }
  &.small {
    font-size: 18px;
  }
`